// extracted by mini-css-extract-plugin
export default {"svgMapSectionName":"SvgMapSectionNames_svgMapSectionName__2V1NN"};